// extracted by mini-css-extract-plugin
export default {"pagination-container":"Home_pagination-container__gLCfp","pagination":"Home_pagination__YPvGj"};